import {Country} from '../../../models/Country';
import * as CountriesConstants from '../constants/Countries';

interface CountriesState {
  isLoading: boolean;
  collection: Country[];
}

const initialState: CountriesState = {
  isLoading: false,
  collection: []
};

export function countries(state = initialState, action): CountriesState {
  switch (action.type) {
    case CountriesConstants.FETCH_COUNTRIES_STARTED:
      return {...state, isLoading: true};
    case CountriesConstants.FETCH_COUNTRIES_COMPLETED:
      return {...state, isLoading: false, collection: action.countries};
    default:
      return state;
  }
}
